/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/feature_limitations" endpoint
 */
import qs from "qs";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdFeatureLimitations } from "./constants";
import type { EngagementAppGroupIdFeatureLimitationsResult, LimitData } from "./types";
import { isEngagementAppGroupIdFeatureLimitationsResult } from "./validators";

export const getEngagementAppGroupIdFeatureLimitations = reactQueryFetcherAdapter(
  engagementAppGroupIdFeatureLimitations,
  (
    signal: AbortSignal,
    appGroupId: string,
    limitData: LimitData
  ): Promise<EngagementAppGroupIdFeatureLimitationsResult> => {
    return fetch(
      `/engagement/${appGroupId}/feature_limitations?${qs.stringify({ limit_data: limitData }, { encode: false })}`,
      "GET",
      undefined,
      { signal },
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  },
  isEngagementAppGroupIdFeatureLimitationsResult
);
